// colors
import { colors } from '../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    backgroundColor: colors.indigo200,
    padding: '16px',
    gap: '16px',
  },
  mainContent: {
    backgroundColor: colors.neutral50,
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'calc(100vh - 80px)',
  },
  publisherVideo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  subscriberVideo: {
    width: '100%',
  },
  waitingScreen: {
    padding: '64px',
    flex: 1,
    width: '100%',
    gap: 64,
  },
  boxLeft: {
    flex: 1,
  },
  videoContainer: {
    position: 'relative',
    flex: 1,
    zIndex: 1,
    transition: 'all 0.3s ease-in-out',
  },
  rightPanel: {
    width: 0,
    position: 'relative',
    transition: 'all 0.3s ease-in-out',
    backgroundColor: colors.white,
  },
  showRightPanel: {
    borderLeft: `1px solid ${colors.neutral100}`,
    width: 400,
  },
  sharePanel: {
    width: 321,
  },
  priorityPanel: {
    width: 752,
  },
  chatPanel: {
    width: 440,
  },
  inPersonRightPanel: {
    width: '100% !important',
  },
  schedulePanel: {
    width: 560,
  },
  notePanel: {
    width: 336,
  },
  checklistPanelNoVideo: {
    width: '100%',
    margin: '0 auto',
  },
  checklistPanel: {
    width: '50%',
    margin: '0 auto',
  },
  initialEvaluationPanel: {
    minWidth: 520,
    display: 'flex',
  },
  inProgressEvaluationPanel: {
    minWidth: 360,
    display: 'flex',
  },
  inProgressEvaluationPanelWidth: {
    minWidth: '50%',
    display: 'flex',
  },
  evaluationRightPanel: {
    width: 'calc(100vw - 1060px)',
  },
  evaluationRightPanelNoVideo: {
    width: '50%',
  },
  rightPanelNoVideo: {
    width: 'calc(100vw - 360px)',
  },
  video: {
    width: '100%',
    height: '100%',
    backgroundColor: colors.neutral900,
  },
  disconnectedVideo: {
    width: '100%',
    height: '100%',
    backgroundColor: '#fef1f2',
  },
  hiddenVideo: {
    width: '0%',
    height: '0%',
    backgroundColor: colors.neutral900,
  },
  noVideo: {
    width: '100%',
    backgroundColor: colors.neutral50,
  },
  username: {
    fontSize: 18,
    lineHeight: '24px',
    margin: 0,
    marginTop: 24,
  },
  fullname: {
    fontSize: 14,
    lineHeight: '20px',
    margin: 0,
  },
  fullWidth: {
    width: '100%',
  },
  chatDrawer: {
    '& .MuiPaper-root': {
      maxWidth: '640px !important',
    },
  },
  scheduleDrawer: {
    '& .MuiPaper-root': {
      maxWidth: '640px !important',
    },
  },
  inPersonContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  dashboardScroll: {
    overflowY: 'auto',
  },
  flexContainer: {
    display: 'flex',
  },
  memberProfileDrawer: {
    '& .MuiPaper-root': {
      backgroundColor: colors.neutral50,
      maxWidth: '680px !important',
    },
  },
  subscriberVideoContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 4,
    zIndex: 10,
  },
  subscriberVideo: {
    height: '100vh',
    width: '100%',
    position: 'relative',
    display: 'block',
  },
  subscriberVideoMini: {
    width: '200px',
    height: '114px',
    '& .OT_subscriber': {
      border: `3px solid ${colors.white}`,
      borderRadius: 8,
    },
  },
  screenShareVisible: {
    display: 'block',
    height: '100vh',
    width: '100%',
  },
  streamHidden: {
    display: 'none',
  },
  // 3-Column Layout Sections
  waitingSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    gap: '16px',
  },
  waitingSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: colors.white,
    borderRadius: '16px',
    overflow: 'hidden',
    minHeight: 0,
  },
  waitingSectionBody: {
    flex: 1,
    overflowY: 'auto',
    padding: '64px',
    minHeight: 0,
  },
  waitingSectionAMA: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    '& > div': {
      // Target AskMeAnythingSession container
      height: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
    },
    '& .container': {
      // Override AskMeAnythingSession container height
      height: '100% !important',
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  waitingSectionFooter: {
    display: 'flex',
    padding: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: '16px',
    border: `1px solid ${colors.neutral100}`,
    cursor: 'pointer',
  },
  footerText: {
    fontSize: 16,
    fontWeight: 500,
    color: colors.neutral500,
  },
  footerBtn: {
    width: 48,
    height: 48,
    padding: 0,
    minWidth: 0,
    background: colors.neutral50,
    border: 'none',
  },
  streamSection: {
    overflow: 'auto',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  sessionContentSection: {
    flex: 1.8,
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
  },
  scratchpadInputBox: {
    paddingBottom: '16px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  scratchpadInput: {
    border: 'none !important',
    padding: '0px 16px',
  },
});
